import {
  __,
  add,
  compose,
  divide,
} from 'ramda'

/**
 * Calculates the expires on values based on the current time and the cache pool's TTL value.
 *
 * @param {HttpCachePoolConfig} poolConfig
 * @return {Number}
 */
const calculateExpiresOnValue = (poolConfig) => compose(
  Number,
  Math.floor,
  add(poolConfig.timeToLive),
  divide(__, 1000),
)((new Date()).getTime())

export default calculateExpiresOnValue
